module.exports = __webpack_public_path__ + "assets/img/more-btn-af4a790c.png";